@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container">
      <tidy-text [header]="'Vendors'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Add Vendor'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToAddVendor()" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      @if (isFetching && loaded) {
        <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
      }
    </div>
  </tidy-desktop-header>
}

@if (!loaded) {
  <div style="width: 100%">
    <ion-skeleton-text animated="true" style="height: 60px; border-radius: 6px" />
  </div>
  <div style="width: 100%; padding-top: 1rem;">
    <ion-skeleton-text animated="true" style="height: 220px; border-radius: 6px" />
  </div>
}

@if (!windowService.isDesktopRes && loaded) {
  <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 8px; width: 100%;">
    <div style="flex: 1; min-width: 0;">
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          [fixedWidth]="false"
          class="header-search" />
      </form>
    </div>
    <div style="flex: 0 0 auto;">
      <tidy-small-button
        [text]="'Add'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToAddVendor()" />
    </div>
  </div>
}

@if (loaded && hasResults() && windowService.isDesktopRes) {
  <tidy-card class="no-padding">
    <tidy-table
      [dataSource]="rows"
      [displayedColumns]="headers"
      [columnslabels]="headers"
      [allRowIsClickable]="true"
      [enableVirtualScrolling]="false"
      (cellClick)="onTableCellClick($event)" />
  </tidy-card>
}

@if (loaded && hasResults() && !windowService.isDesktopRes) {
  @for (vendor of allVendors; track vendor.id) {
    <tidy-card>
      <tidy-card-button
        (action)="goToVendorDetail(vendor)"
        class="arrow-to-top no-padding">
        <tidy-row>
          <tidy-initials-icon [fullName]="vendor.name || '—'" />
          <tidy-text [header]="vendor.name || '—'" [translate]="false" />
        </tidy-row>
      </tidy-card-button>
      @if (vendor.vendor_category?.name) {
        <tidy-row>
          <tidy-text [helper]="vendor.vendor_category.name" [translate]="false" />
        </tidy-row>
      }
      @if (vendor.email) {
        <tidy-row>
          <tidy-text [body]="vendor.email" [translate]="false" />
        </tidy-row>
      }
      @if (vendor.phone) {
        <tidy-row>
          <tidy-text [helper]="vendor.phone" [translate]="false" />
        </tidy-row>
      }
      <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
        <tidy-text [helper]="'Tap to view'" />
        <tidy-image
          [src]="'assets/svg/trash-outline.svg'"
          class="vendor-delete-icon"
          (action)="confirmDelete(vendor)" />
      </tidy-row>
    </tidy-card>
  }
}

@if (loaded && isEmpty()) {
  <tidy-card class="vendors-empty-card">
    <div class="vendors-empty">
      <div class="vendors-empty-illustration">
        <tidy-image
          [src]="'assets/svg/briefcase-outline.svg'"
          class="vendors-empty-icon" />
      </div>

      <tidy-row [align]="'center'">
        <tidy-text [title]="'No vendors yet'" />
      </tidy-row>

      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text
          [body]="'Add vendors for non-job services (plumbing, landscaping, repairs) and create invoices to pay them by check.'" />
      </tidy-row>

      <tidy-button
        [text]="'Add Your First Vendor'"
        [image]="'assets/img/add-button-white.svg'"
        [action]="boundGoToAddVendor"
        class="primary" />

      <tidy-row [align]="'center'" class="extra-top-padding vendors-empty-perks-row">
        <div class="vendors-empty-perks">
          <div class="vendors-empty-perk">
            <tidy-image [src]="'assets/svg/person-add-outline.svg'" />
            <tidy-text [body]="'Keep vendor contact info in one place'" />
          </div>
          <div class="vendors-empty-perk">
            <tidy-image [src]="'assets/svg/document-text-outline.svg'" />
            <tidy-text [body]="'Generate invoices for non-job services'" />
          </div>
          <div class="vendors-empty-perk">
            <tidy-image [src]="'assets/svg/checkmark-circle-outline.svg'" />
            <tidy-text [body]="'Pay vendor invoices by check from your account'" />
          </div>
        </div>
      </tidy-row>
    </div>
  </tidy-card>
}

@if (loaded && isEmptySearch()) {
  <tidy-card>
    <tidy-row [align]="'center'">
      <tidy-text [body]="'No results match your search.'" />
    </tidy-row>
  </tidy-card>
}

@if (loaded && totalCount > perPage) {
  <tidy-row [align]="'center'" class="vendors-pager">
    <tidy-text
      [actionBody]="'Previous'"
      (action)="prevPage()"
      [ngClass]="canGoPrev() ? 'link' : 'disabled-link'" />
    <tidy-text
      [helper]="rangeStart() + '–' + rangeEnd() + ' of ' + totalCount"
      [translate]="false" />
    <tidy-text
      [actionBody]="'Next'"
      (action)="nextPage()"
      [ngClass]="canGoNext() ? 'link' : 'disabled-link'" />
  </tidy-row>
}

@if (errorMessage) {
  <tidy-error-message [text]="errorMessage" />
}
